import React, { useEffect } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import '../../../Static/Master/firmtable.css';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import PreviewIcon from '@mui/icons-material/Preview';
import { Button } from '@mui/material';
import { deleteSingleCutting } from '../../../Store/PHPSlice/Cutting/cuttingApi';
import EditIcon from '@mui/icons-material/Edit';
const TableBody = ({
    serialNumber,
    id,
    dt,
    ordType,
    sono,
    empType,
    empTypeNm,
    masterNm,
    memoNo,
    firmId,
    firmNm,
    instruction,
    sts,
    cnt_cutId,
    cIssId,
    selected,
    handleClick,
}) => {
    const dispatch = useDispatch();

    const handleDeleteClick = () => {

        const isConfirmed = window.confirm("Are you sure you want to delete this Cutting Entry?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleCutting({ id, cIssId }))
                .then(() => {
                    // Reload the page to show updated results
                    toast.success("Cutting Entry Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting Item:", error);
                    toast.error("Failed to delete Item");
                });
        }


    };

    const handleViewClick = () => {
        window.open(`/CuttingInfoView/${memoNo}`, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleReturnClick = () => {
        window.open(`/CuttingInward/${memoNo}`, '_blank', 'width=1200,height=700,scrollbars=yes,resizable=yes');
    };


    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open
        window.open(`/CuttingInEdit/${id}`, '_blank', 'width=1100,height=800,scrollbars=yes,resizable=yes');
    };


    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {dt}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {memoNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {firmNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {ordType}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {sono}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {empTypeNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    {masterNm}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <PreviewIcon className='cursor-pointer' onClick={handleViewClick} />
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <Button variant="contained" color="primary" onClick={handleReturnClick} disabled={sts === '1'}>Return</Button>
                </TableCell>

                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className={`cursor-pointer ${cnt_cutId !== '0' ? 'disabled-icon' : ''}`} onClick={handleEditClick} />
                </TableCell> */}

                <TableCell sx={{ p: 1, border: '1px solid #000', whiteSpace: 'nowrap' }} align='center'>
                    <DeleteIcon className={`cursor-pointer ${cnt_cutId !== '0' ? 'disabled-icon' : ''}`} onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
        </>
    );
};

export default React.memo(TableBody);
